var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndDateIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66683 3.33325C2.3132 3.33325 1.97407 3.47373 1.72402 3.72377C1.47397 3.97383 1.3335 4.31296 1.3335 4.66659V17.3333C1.3335 17.6869 1.47397 18.0261 1.72402 18.2761C1.97407 18.5261 2.3132 18.6666 2.66683 18.6666H17.3335C17.6871 18.6666 18.0263 18.5261 18.2763 18.2761C18.5263 18.0261 18.6668 17.6869 18.6668 17.3333V4.66659C18.6668 4.31296 18.5263 3.97383 18.2763 3.72377C18.0263 3.47373 17.6871 3.33325 17.3335 3.33325H14.6668",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 8H18.6668",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 1.33325V5.33325",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 1.33325V5.33325",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 3.33325H12.0002",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndDateIconWhite);
export default __webpack_public_path__ + "static/media/endDate_icon_white.9719b2899bdad1167226345da3dff851.svg";
export { ForwardRef as ReactComponent };